function t() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(n) {
    const x = Math.random() * 16 | 0;
    return (n === "x" ? x : x & 3 | 8).toString(16);
  });
}
export {
  t as generateUUID
};
